import React from "react"
import { useSelector } from "react-redux"
import _ from "lodash"
import { Grid } from "@material-ui/core"
import PropTypes from "prop-types"
import { defineMessages } from "react-intl"
import AnalyticsCard from "../../component/AnalyticsCard"

const messages = defineMessages({
  document: {
    id: "document.document",
    defaultMessage: "document(s)"
  },
  statement: {
    id: "statement.statement",
    defaultMessage: "statement(s)"
  },
  waitingCardSubTitle: {
    id: "document.card.waiting.subtitle",
    defaultMessage: "Need your attention"
  },
  recentCardSubTitle: {
    id: "document.card.recent.subtitle",
    defaultMessage: "Added recently"
  },
  lastDocumentSubTitle: {
    id: "document.card.last.subtitle",
    defaultMessage: "Last summary upload date"
  },
  lastStatementSubTitle: {
    id: "statement.card.last.subtitle",
    defaultMessage: "Last statement made available"
  }
})
export default function DocumentAnalyticsSection(props) {
  const { category } = props
  let cards = useSelector((state) => state.documents.analytics)
  if (cards && cards.length > 0) {
    const tmp = cards.map((item) => {
      if (category === "statement") {
        if (item.isRecentDoc) {
          return {
            ...item,
            subtitle: messages.recentCardSubTitle,
            textSecondary: messages.statement
          }
        }
        return {
          ...item,
          subtitle: messages.lastStatementSubTitle
        }
      }
      if (item.isRecentDoc) {
        return {
          ...item,
          subtitle: messages.recentCardSubTitle,
          textSecondary: messages.document
        }
      }
      return {
        ...item,
        subtitle: messages.lastDocumentSubTitle
      }
    })
    cards = tmp
  }
  const loopOver = _.isEmpty(cards) ? _.range(3) : cards

  return (
    <Grid container justify="center" spacing={1}>
      {_.map(loopOver, (item, idx) => (
        <Grid sm={6} xs={12} item key={`doc-analytics-${idx}`}>
          <AnalyticsCard {...item} />
        </Grid>
      ))}
    </Grid>
  )
}
DocumentAnalyticsSection.propTypes = {
  category: PropTypes.any.isRequired
}
